module.exports = __webpack_public_path__ + "static/media/Header_admin.9c76f9b7.jpg";